import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { BusinessAccountService } from "../api/generated/services/BusinessAccountService";
import "../api/openApiConfig";

const OnBehalfOfBanner: React.FC = () => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  if (!user?.isLoggedInOnBehalfOfCompany) {
    return null;
  }

  const handleBackToAdmin = async () => {
    try {
      setIsLoading(true);
      await BusinessAccountService.postApiBusinessAccountLogoutFromBehalfOfCompany({});
      // Full page refresh to partner management on success
      window.location.href = "/admin-partner-management";
    } catch (error) {
      console.error("Error logging out from behalf of company:", error);
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed top-4 right-4 z-[9999]">
      <button
        onClick={handleBackToAdmin}
        disabled={isLoading}
        title="Logged in on behalf of partner - Click to return to Admin Dashboard"
        className="w-10 h-10 bg-purple-600 hover:bg-purple-700 text-white rounded-full shadow-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        {isLoading ? (
          <svg
            className="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
        )}
      </button>
    </div>
  );
};

export default OnBehalfOfBanner;
